import { useBaseHook } from './useBaseHook'

export const usePost = (API) => {

    const { onApply, isLoading } = useBaseHook(API)

    const onPost = (reqbody, action) => onApply("post-operation", reqbody, action)

    return { onPost, isLoading }
}
